<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;" v-if="config.syncDeptmentEnabel===false">添加</el-button>
    <el-table
      row-key="id"
      :data='tableData'
      :tree-props="{children: 'children'}"
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '260'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'organizationId'
        label= '组织id'>
      </el-table-column>
      <el-table-column
        prop= 'parentId'
        label= '父级id'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '160' v-if="config.syncDeptmentEnabel===false">
        <template slot-scope='scope'>
          <el-button @click='addChild(scope.row)' type='text' size='small' style="color: #209323">添加子部门</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false">
      <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="组织id" :label-width="formLabelWidth">
          <el-input v-model="form.organizationId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="父级ID" :label-width="formLabelWidth">
          <el-input v-model="form.parentId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" v-if="config.syncDeptmentEnabel===false">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  props: {
    organizationId: {
      type: Number,
      default: 0,
      required: false
    },
    organizationName: {
      type: String,
      default: '',
      required: false
    }
  },
  data () {
    return {
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        organizationId: null,
        parentId: null
      },
      config: {},
      formLabelWidth: '120px'
    }
  },
  created () {
    
    this.config = JSON.parse(localStorage.getItem('appConfig') + '')
  },
  mounted () {
  },
  updated () {
  },
  watch: {
    organizationId: {
      handler (newV, oldV) {
        this.form.organizationId = this.organizationId
        this.query()
      },
      immediate: true
    }
  },
  methods: {
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/department/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/department/list?organizationId=${that.organizationId}&dealTree=true`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body
      })
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {organizationId: this.organizationId}
      this.dialogFormVisible = true
    },
    addChild (row = {}) {
      this.form = {organizationId: row.organizationId, parentId: row.id}
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/department/add'
      if (that.form.id) {
        url = '/department/edit'
      }
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/department/Index.vue